export default function hasParentClass(element, classNames) {
  if (!Array.isArray(classNames)) {
    classNames = [classNames]
  }

  let currentElement = element

  while (currentElement) {
    for (const className of classNames) {
      if (currentElement.classList?.contains(className)) {
        return true
      }
    }

    currentElement = currentElement.parentNode
  }

  return false
}
